// Vue 2 mixin that exposes reactive `isMobile` based on viewport width.
//
// Mobile breakpoint matches the designer's iPhone-class mockups (< 768px).
// Components mix this in to branch their style-computed maps between desktop
// and mobile layouts:
//
//   import viewportMixin from "../c-design/useViewport";
//   export default {
//     mixins: [viewportMixin],
//     computed: {
//       wrapStyle() {
//         return this.isMobile
//           ? { padding: '14px 12px 24px' }
//           : { padding: '24px 16px 40px' };
//       },
//     },
//   };
//
// The mixin owns one resize listener per component instance. That's intentional
// — wizard screens mount/unmount one at a time, so we only ever have a handful
// of listeners alive at once. If that changes, replace with a singleton store
// of the value.

const MOBILE_MAX_WIDTH = 768;

// IMPORTANT: the data prop name MUST NOT start with `_` or `$` — Vue 2
// does not proxy underscore- or dollar-prefixed keys through `this`, so
// `this.__viewportWidth` (the earlier name) resolved to `undefined` and
// `isMobile` was always false. That silently disabled every mobile
// branch in the wizard (brand-strip, sticky nav, sticky CTA, sub-step
// trail). Using `cdVpW` — short, no special prefix, namespaced enough.
// See: https://v2.vuejs.org/v2/api/#data
export default {
    data() {
        return {
            cdVpW:
                typeof window !== "undefined" ? window.innerWidth : 1024,
        };
    },
    computed: {
        isMobile() {
            return this.cdVpW > 0 && this.cdVpW < MOBILE_MAX_WIDTH;
        },
    },
    mounted() {
        if (typeof window === "undefined") {
            return;
        }
        this.cdVpW = window.innerWidth;
        // The resize-handler reference doesn't need to be reactive — we
        // just need a stable function we can later removeEventListener
        // on. Underscore prefix is fine here (Vue's no-proxy rule only
        // applies to keys declared inside `data()`).
        this.__viewportResizeHandler = () => {
            this.cdVpW = window.innerWidth;
        };
        window.addEventListener("resize", this.__viewportResizeHandler, {
            passive: true,
        });
    },
    beforeDestroy() {
        if (this.__viewportResizeHandler) {
            window.removeEventListener("resize", this.__viewportResizeHandler);
            this.__viewportResizeHandler = null;
        }
    },
};
